import { Configuration, FrontendApi } from "@ory/kratos-client";
import { config } from "~/config";

export const kratos = new FrontendApi(
	new Configuration({
		basePath: config.kratosURL,
		baseOptions: {
			withCredentials: true,
		},
	}),
);
